import tripEvents from '../../config/events.constant';
import template from './adultTraveller.html';
import templateTripDetails from '../../directives/templates/tripDetails/adultTraveller.tmpl.html';

import './adult-traveller.scss';

const DIRECTIVE_NAME = AdultTraveller.DIRECTIVE_NAME = 'adultTraveller';

export default function AdultTraveller($timeout) {
    'ngInject';
    return {
        restrict: 'A',
        template: function(el, attr) {
            return attr.template ? templateTripDetails : template;
        },
        scope: {
            adult: '=',
            model: '=',
            index: '=',
            travellers: '=',
            send: '&',
            lists: '=',
            isLocked: '=',
            isDisable: '=',
            isCancelled: '=',
            wasConfirmed: '=',
            sendDocumentation: '=',
            selectedSeats: `=${DIRECTIVE_NAME}SelectedSeats`,
        },
        controller: AdultTravellerController,
        controllerAs: '$ctrl',
        link: function($scope, $elem, $attrs, adultTravellerCtrl) {
            adultTravellerCtrl.$onInit();
            $scope.$on(tripEvents.TRIP_REFRESH_CHECKOUT_FORM_STATE, () => {
                $timeout(() => {
                    adultTravellerCtrl.$onInit();
                });
            });
        },
    };
}

export function AdultTravellerController(
    $scope,
    $rootScope,
    $state,
    $window,
    tripFactory,
    travellerUtils,
    userService,
    l10nService,
    tripAPI,
    flightsUtils,
    adultTravellerService,
    tripService
) {
    'ngInject';
    const vm = this;
    const OWNED_BY_ANOTHER_TRAVELLER_MESSAGE = l10nService.localize('This profile is owned by another user and cannot be viewed.');
    const ADDITIONAL_FIELDS_REQUIRED_MESSAGE = l10nService.localize('Please note that additional details are required for this trip.');
    const KNOWN_TRAVELLER_POPUP = 'A known Traveller is a person that has been approved by the Pre✓™ application program (Global Entry, NEXUS or SENTRI) and is issued a Known Traveller Number. '
        + 'This program maintains high security standards & improves passenger experience by providing expedited screening through the TSA Pre✓™ lanes';
    const REDRESS_NUMBER_POPUP = 'A Redress number is a number issued by the US Department of Homeland Security Traveller Redress Inquiry Program (DHS TRIP) and prevents misidentifications for people that have names similar to individuals on the watch list. '
        + 'If provided, this number will be used in bookings to the US';

    Object.assign(vm, {
        $onInit,
        isGenderRequired,
        isAddDetailsManuallyLinkVisible,
        isSendDocumentationOptionVisible,
        showTravellerDetails,
        onConfirmationSelect,
        searchTravellerProfiles,
        isEditIconEnabled,
        handleEditClick,
        handleMailClick,
        isMailIconEnabled,
        cancel,
        allowControlEditing,
        isAdditionalProfileInfoVisible,
        isMobileVisible,
        isMobileRequired,
        isMissingField,
        canMobileBeAmended,
        showGender,
        l10nService,
        OWNED_BY_ANOTHER_TRAVELLER_MESSAGE,
        ADDITIONAL_FIELDS_REQUIRED_MESSAGE,
        REDRESS_NUMBER_POPUP,
        KNOWN_TRAVELLER_POPUP,
        isTravellerDetailsExpanded: false,
        isConfirmationMessageVisible: false,
        isEmailDuplicated: false,
        isOwner: true,
        isProfileCreationMode: true,
        isEmailEditingEnabled: true,
        isAdditionalProfileInfoRequired: false,
        wasFormSubmitted: false,
        canEditMobile: false,
    });

    function $onInit() {
        initScope($scope);
        initTitles();
        initTravellerFormEditing();
        checkFFNVisibility();
    }

    function isMobileRequired() {
        return !$scope.model.IsRailsOrEuRailsOnly
            && !$scope.model.IsOfflineTrip;
    }

    function initTravellerFormEditing() {
        const {IsCompleted, IsOwnedTravellerProfile, TravellerProfileId} = $scope.adult;
        if (IsCompleted && !!TravellerProfileId) {
            vm.isOwner = IsOwnedTravellerProfile;
        }
    }

    function initTitles() {
        vm.titles = travellerUtils.processTitles($scope.lists.adultTravellerTitles, $scope.model);
    }
    function isEditIconEnabled() {
        return travellerUtils.isEditIconEnabled(
            $scope.isLocked,
            $scope.isDisable,
            $scope.isCancelled,
            $scope.model
        );
    }
    function handleEditClick() {
        if (vm.isEditIconEnabled()) {
            return $scope.edit();
        }
    }

    function isMobileVisible() {
        if (!vm.isOwner && !$scope.model.IsRailsOrEuRailsOnly && !$scope.model.IsOfflineTrip || !$scope.adult.IsCompleted) {
            return true;
        }
        return !$scope.model.IsOfflineTrip
            && (vm.isOwner
                || !$scope.editedAdult.TelephoneNumber
                && $scope.isFlightPresent
                && tripService.isMobileRequired($scope.model.ApisTsaSettings)
            );
    }

    function handleMailClick() {
        if (!$scope.model.IsOfflineTrip) {
            return $scope.sendTripToReview();
        }
    }
    function isMailIconEnabled() {
        return !($scope.isSendTripToReviewDisabled()
            || $scope.model.IsOfflineTrip);
    }

    function isGenderRequired() {
        const tripDetails = $scope.model;
        const editedAdult = $scope.editedAdult;

        return travellerUtils.isGenderRequiredForAnyFlight(tripDetails, editedAdult)
            || travellerUtils.isGenderRequiredForAnyHotel(tripDetails, editedAdult)
            || apisHasLevel(0);
    }

    function cancel() {
        angular.copy($scope.adult, $scope.editedAdult);
        $scope.adult.isOpenedForm = false;
        vm.isEmailEditingEnabled = true;
        $scope.isDuplicateError = false;
    }

    function showTravellerDetails() {
        vm.isProfileCreationMode = !$scope.adult.TravellerProfileId;
        vm.isTravellerDetailsExpanded = true;
        vm.isConfirmationMessageVisible = false;
    }

    function isAddDetailsManuallyLinkVisible(adult) {
        return adult.isOpenedForm
            && !vm.isTravellerDetailsExpanded
            && !$scope.model.IsOfflineTrip;
    }

    function searchTravellerProfiles(query) {
        return tripAPI.searchTravellerProfiles({SearchData: query, TripId: $scope.model.Id});
    }

    function checkFFNVisibility() {
        vm.isFFNVisible = $scope.isFlightPresent
            && !!$scope.model.Flights.find((flight) => !flightsUtils.isItemTrain(flight))
            && vm.isOwner
            && !$scope.model.IsOfflineTrip;
    }

    function isMissingField(field) {
        return _.includes($scope.editedAdult.MissingFields, field);
    }

    function initScope(scope) {
        $scope.regionalSettings = userService.getRegionalSettings();
        scope.l10n = l10nService;

        const tripId = scope.model.Id;
        const errors = {
            duplicatePassenger: false,
            passportExpire: false,
        };
        $scope.$on(tripEvents.TRIP_DETAILS_UPDATE_FOR_SEATS_FINISHED, () => {
            if (vm.inEdit) {
                vm.inEdit = false;
                adultTravellerService.updateClubCards(scope.model.Travelers.Adult, scope.editedAdult);
            }
        });
        scope.errors = angular.copy(errors);

        scope.sendTripToReview = function() {
            if (!(scope.isLocked || scope.isCancelled)) {
                scope.send({person: scope.adult});
            }
        };

        scope.isUkRailPresent = scope.model.IsRailTripItemExist || scope.model.IsDateOfBirthRequiredForEuRails;

        scope.hasTravelfusionFlights = flightsUtils.hasTravelfusionFlights($scope.model);

        scope.dateOfBirthDatepickerOptions = {
            max: scope.model.IsDateOfBirthRequiredForEuRails ? moment(scope.model.MaximumChildDob).add(-5, 'years') : moment(scope.model.MaximumChildDob),
        };

        scope.isSendTripToReviewDisabled = function() {
            return !scope.adult.IsCompleted || scope.isLocked || scope.isCancelled;
        };

        scope.selectedUser = {
            model: '',
        };

        const emptyAdult = travellerUtils.processTraveller({
                TripPassengerId: scope.adult.Id,
                PassengerType: 'Adult',
                HasMultiplePassports: false,
                ClubCards: [],
                EmailAddress: '',
            },
            scope.model.Travelers,
            scope.adult.positionIndex
        );

        scope.editedAdult = Object.assign(angular.copy(scope.adult),
            {birthDayOpen: false, expireDateOpen: false});
        scope.isPhoneWasEntered = !!scope.editedAdult.TelephoneNumber;
        scope.editedAdult.TripPassengerId = scope.editedAdult.Id;

        travellerUtils.addTravellerAdditionalFields(scope.editedAdult, scope.model.Travelers);

        scope.getToggleDropDown = function(dropdownKey = 'birthDayOpen') {
            scope.editedAdult[dropdownKey] = false;
        };

        scope.isActive = scope.model.IsEditable;
        scope.isFlightPresent = scope.model.IsFlightTripItemExist;
        scope.isDateOfBirthRequiredForEuRails = scope.model.IsDateOfBirthRequiredForEuRails;

        scope.saveTraveller = function(traveller, editTraveller, findProfileTrigger) {
            scope.isDuplicateError = !!travellerUtils.findTravellerNameDuplication(editTraveller, scope.model.Travelers);

            if (scope.isDuplicateError) {
                traveller.IsCompleted = false;
                vm.isTravellerDetailsExpanded = true;
                return;
            }

            saveTraveller();

            function saveTraveller() {
                travellerUtils
                    .saveTraveller(
                        editTraveller,
                        tripId,
                        scope.isFlightPresent,
                        scope.isUkRailPresent,
                        traveller.positionIndex,
                    )
                    .then(({data}) => {
                        vm.isTravellerDetailsExpanded = false;
                        vm.isProfileCreationMode = !editTraveller.TravellerProfileId;
                        vm.isConfirmationMessageVisible = shouldShowConfirmationMessage(editTraveller, vm.isProfileCreationMode, vm.isOwner);

                        scope.selectedUser.model = '';
                        editTraveller.TripPassengerId = data.TripPassengerId;
                        editTraveller.Id = data.TripPassengerId;
                        _.extend(
                            traveller,
                            editTraveller,
                            {
                                IsContact: false,
                                IsCompleted: true,
                                isOpenedForm: false,
                                MiddleName: editTraveller.MiddleName || null,
                            },
                            function(value, other) {
                                if (other === '') {
                                    return null;
                                } else if (_.isObject(other)) {
                                    return angular.copy(other);
                                }
                                    return other;

                            });
                        scope.editedAdult.isAutoSave = false;
                        vm.isAdditionalProfileInfoRequired = false;
                        vm.wasFormSubmitted = !findProfileTrigger;
                        $window.scrollTo(0, 0);
                        if (vm.isEmailDuplicated) {
                            closeConfirmationMessageAndUpdate();
                        }
                        vm.inEdit = true;
                        $rootScope.$broadcast(tripEvents.TRIP_DETAILS_UPDATE);
                        $rootScope.$broadcast(tripEvents.TRIP_ADULT_SAVED);
                    })
                    .catch((res) => {
                        vm.isTravellerDetailsExpanded = true;
                        traveller.IsCompleted = false;
                        scope.errors.ServerError = true;
                        if (res.hasOwnProperty('data')) {
                            scope.errors.message = res.data.ErrorMessage;
                        }
                    });
            }
        };

        function shouldShowConfirmationMessage(traveller, creationMode, isOwner) { // eslint-disable-line
            if (!creationMode && !isOwner) {
                return false;
            }
            if (traveller.isAutoSave || vm.isEmailDuplicated) {
                return false;
            }
                const clubCards = traveller.ClubCards || [];
                if (!traveller.TravellerProfileId || clubCards.changed || (!creationMode && vm.adultForm.$dirty)) {
                    if (clubCards.changed) {
                        traveller.ClubCards.changed = false;
                    }
                    return true;
                }

            return false;
        }

        scope.passportExpireDatepickerOptions = {
            min: moment(scope.model.TripLastDate).add({months: 6}),
        };

        scope.collapseTravellerForm = function(traveller) {
            traveller.isOpenedForm = !traveller.isOpenedForm;
            vm.isTravellerDetailsExpanded = scope.adult.IsCompleted;
            vm.isEmailEditingEnabled = !scope.editedAdult.TravellerProfileId;
            vm.isConfirmationMessageVisible = false;
        };

        scope.addTravellerInformation = function() {
            if (scope.isActive && !scope.wasConfirmed && !scope.model.IsOfflineTrip) {
                scope.collapseTravellerForm(scope.adult);
                if ($scope.adult.IsBookForYourselfOnly) {
                    showTravellerDetails();
                }
            }
        };

        scope.getFullName = travellerUtils.getTravellerFullName;
        scope.edit = function() {
            if ($rootScope.readOnlyMode) {
                $state.go('login');
            }
            scope.adult.isOpenedForm = !scope.adult.isOpenedForm;
            vm.isTravellerDetailsExpanded = true;
            const hasNoProfile = !$scope.adult.TravellerProfileId;
            vm.isProfileCreationMode = hasNoProfile;
            vm.isEmailEditingEnabled = hasNoProfile;
            vm.isConfirmationMessageVisible = false;
        };

        scope.restoreData = function(restoreFormState) {
                if (restoreFormState && !scope.adult.IsContact) {
                    angular.copy(scope.adult, scope.editedAdult);
                } else {
                    const {TripPassengerId} = scope.editedAdult;
                    angular.copy(emptyAdult, scope.editedAdult);
                    angular.copy(emptyAdult, scope.adult);
                    scope.editedAdult.TripPassengerId = TripPassengerId;
                    vm.isOwner = true;
                }
                scope.adult.isOpenedForm = !restoreFormState;
                vm.isEmailEditingEnabled = true;
                scope.isDuplicateError = false;
                vm.isOwner = true;
                vm.isAdditionalProfileInfoRequired = false;
                vm.adultForm.$setPristine();
                checkFFNVisibility();
        };

        scope.findTraveller = function(adult, contact) {
            const isPassportInfoRequired = tripService.isPassportInfoRequired(scope.model.ApisTsaSettings);
            const isProfileComplete = adultTravellerService.isProfileComplete(
                contact,
            );

            angular.copy(errors, scope.errors);
            if (contact.IsOwner && isPassportInfoRequired && checkPassportExpire(contact)) {
                scope.errors.passportExpire = true;
                return false;
            }

            scope.selectedUser.model = '';
            vm.isAdditionalProfileInfoRequired = !isProfileComplete;
            if (vm.isAdditionalProfileInfoRequired && $scope.model.IsRailsOrEuRailsOnly) {
                vm.isAdditionalProfileInfoRequired = false;
            }
            adult.IsCompleted = isProfileComplete;
            scope.isPhoneWasEntered = !!contact.TelephoneNumber;
            const TripPassengerId = scope.editedAdult.TripPassengerId || scope.adult.TripPassengerId;
            scope.editedAdult = angular.copy(emptyAdult);
            scope.adult.TravellerProfileId = contact.Id;
            _.extend(scope.editedAdult, contact, {
                TravellerProfileId: contact.Id,
                isAutoSave: isProfileComplete,
                TripPassengerId,
            });
            scope.editedAdult = travellerUtils.processTraveller(scope.editedAdult, scope.model.Travelers, scope.adult.positionIndex);
            vm.isOwner = contact.IsOwner;
            checkFFNVisibility();
            vm.isConfirmationMessageVisible = false;
            vm.isEmailEditingEnabled = false;
            vm.isProfileCreationMode = false;
            vm.canEditMobile = scope.editedAdult.TelephoneNumber === null || (angular.isDefined(scope.editedAdult.TelephoneNumberCallingCode) && scope.editedAdult.TelephoneNumberCallingCode.value === null) || vm.isOwner;

            scope.missingFields = hasMissingFields(contact);

            if (isProfileComplete) {
                scope.saveTraveller(scope.adult, scope.editedAdult, true);
            } else {
                vm.isTravellerDetailsExpanded = true;
                vm.adultForm.$setSubmitted();
            }
        };

        Object.assign(scope, {
            ApisHasLevel: apisHasLevel,
        });

        function checkPassportExpire(traveller) {
                return moment(scope.model.TripLastDate)
                    .add({months: 6})
                    .isAfter(traveller.TravellerFlightDetails.PassportExpiryDate);
            }
    }

    function apisHasLevel(level) {
            return !!tripFactory.apisHasLevel(level, $scope.model.ApisTsaSettings);
        }

    function onConfirmationSelect(saveAsNewProfile) {
        if (saveAsNewProfile) {
            const {isFlightPresent, model: {ApisTsaSettings}} = $scope;

            const createUpdateTravellerProfile = vm.isProfileCreationMode
                ? adultTravellerService.saveTravellerProfile(
                    $scope.editedAdult,
                    isFlightPresent,
                    vm.isGenderRequired(),
                    ApisTsaSettings)
                : adultTravellerService.updateTravellerProfile(
                    $scope.editedAdult,
                    isFlightPresent,
                    vm.isGenderRequired(),
                    ApisTsaSettings);

            createUpdateTravellerProfile
                .then(({data}) => {
                    if (vm.isProfileCreationMode) {
                        Object.assign($scope.editedAdult, {TravellerProfileId: data.Id});
                    }
                })
                .finally(closeConfirmationMessageAndUpdate);

        } else {
            closeConfirmationMessageAndUpdate();
        }
    }

    function closeConfirmationMessageAndUpdate() {
        vm.isConfirmationMessageVisible = false;
        $scope.$emit(tripEvents.TRIP_DETAILS_UPDATE);
        $rootScope.$broadcast(tripEvents.TRIP_ADULT_SAVED);
    }

    function isSendDocumentationOptionVisible() {
        return !!$scope.adult.IsCompleted
            && !$scope.model.IsOfflineTrip
            && !$scope.model.IsRailsOnly;
    }

    function allowControlEditing() {
        return !$scope.model.IsRailsOnly;
    }

    function isAdditionalProfileInfoVisible() {
       return !$scope.adult.IsCompleted || $scope.adult.IsCompleted && vm.isOwner;
    }

    function hasMissingFields(contact) {
        if (angular.isDefined(contact.MissingFields) && contact.MissingFields.length > 0) {
            return contact.MissingFields;
        }
        return null;
    }

    function canMobileBeAmended() {
        return vm.isOwner || !vm.isOwner && $scope.adult.TelephoneNumber === null;
    }

    function showGender() {
        const titleTfCheck = checkTitle();
        const flight = $scope.model.Flights.find((fght) => !flightsUtils.findAmadeusFlights(fght));
        const hotel = $scope.model.Hotels.find((htl) => htl.Supplier === 6);
        const title = $scope.editedAdult.Title.text.trim();
        const euRails = (title === 'Prof' || title === 'Dr' || title === 'Mx') && $scope.model.EuRails && $scope.model.EuRails.length > 0;

        return $scope.model.ApisTsaSettings > 0 || angular.isDefined(flight) || angular.isDefined(hotel) || hasMissingFields('Gender') || titleTfCheck || euRails;
    }

    function checkTitle() {
        const hotel = $scope.model.Hotels.find((htl) => htl.Supplier === 4);
        const title = $scope.editedAdult.Title.text.trim();
        const euRails = $scope.model.EuRails && $scope.model.EuRails.length > 0;

        return (title === 'Prof' || title === 'Dr' || title === 'Mx') && ($scope.hasTravelfusionFlights || angular.isDefined(hotel) || euRails);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/travellers/adult/adultTraveller.directive.js